import { useNavigate, To } from 'react-router-dom';
import { useMemo } from 'react';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectAuth } from '@brands/store/selectors/auth';

export default function useRoleNavigate() {
  const navigate = useNavigate();
  const { userInfo } = useAppSelector(selectAuth);
  const role = userInfo.role.name;

  return useMemo(() => {
    return (to: To | number, options?: { replace?: boolean; state?: any }) => {
      if (typeof to === 'string') {
        if (!to.startsWith(`/${role}`)) {
          to = `/${role}${to.startsWith('/') ? '' : '/'}${to}`;
        }
        navigate(to, options);
      } else if (typeof to === 'number') {
        // Navigate by history steps; no options allowed
        navigate(to);
      } else {
        // to is Location object
        navigate(to, options);
      }
    };
  }, [navigate, role]);
}